import fontelloConfig from "../components/PearsonIcons/icon-font.json";

export const pearsonGlyphNames = new Set(
	fontelloConfig.glyphs.map((glyph) => glyph.css),
);
